/* eslint-disable max-lines */
import { BlockchainAddress } from '~/store/blockchainAddresses/types'
import { BankAccount, CURRENCY, STABLECOIN as STABLECOIN_TYPE } from '~/types'
import { StateFlippers } from './reducer'

export type ACCEPTED_CURRENCY = Exclude<CURRENCY, CURRENCY.IDR | CURRENCY.USDP | CURRENCY.XIDR>

export enum BANK_TRANSFER_NETWORK {
  FAST = 'fast',
  MEPS = 'meps',
  SWIFT = 'swift',
}

export enum TRANSFER_METHOD {
  STABLECOIN = 'stablecoin',
  BANK = 'bank',
}

export type Blockchain =
  | 'zilliqa'
  | 'ethereum'
  | 'hedera'
  | 'polygon'
  | 'avalanche'
  | 'tron'
  | 'bnbsmart'
  | 'arbitrum'
  | 'ripple'

export enum STRAITSX_LANDING_PAGE_ACTIONS {
  SET_TRANSFER_METHOD = 'STRAITSX_LANDING_PAGE_ACTIONS.SET_TRANSFER_METHOD',
  SET_SELECTED_BLOCKCHAIN = 'STRAITSX_LANDING_PAGE_ACTIONS.SET_SELECTED_BLOCKCHAIN',
  SET_SELECTED_BLOCKCHAIN_ADDRESS = 'STRAITSX_LANDING_PAGE_ACTIONS.SET_SELECTED_BLOCKCHAIN_ADDRESS',
  SET_BANK_TRANSFER_NETWORK = 'STRAITSX_LANDING_PAGE_ACTIONS.SET_BANK_TRANSFER_NETWORK',
  SET_SELECTED_BANK_ACCOUNT = 'STRAITSX_LANDING_PAGE_ACTIONS.SET_SELECTED_BANK_ACCOUNT',
  SET_SELECTED_CURRENCY = 'STRAITSX_LANDING_PAGE_ACTIONS.SET_SELECTED_CURRENCY',
  SET_FLIPPERS = 'STRAITSX_LANDING_PAGE_ACTIONS.SET_FLIPPERS',
  SET_ACTIVATION_CHECKLIST_CLICKED_ELEMENT = 'LANDING_PAGE_ACTIONS.SET_ACTIVATION_CHECKLIST_CLICKED_ELEMENT', // added for consistency, not used in biz dashboard
}

export enum LANDING_PAGE_ACTIONS {
  SET_TRANSFER_METHOD = 'LANDING_PAGE_ACTIONS.SET_TRANSFER_METHOD',
  SET_SELECTED_BLOCKCHAIN = 'LANDING_PAGE_ACTIONS.SET_SELECTED_BLOCKCHAIN',
  SET_SELECTED_BLOCKCHAIN_ADDRESS = 'LANDING_PAGE_ACTIONS.SET_SELECTED_BLOCKCHAIN_ADDRESS',
  SET_BANK_TRANSFER_NETWORK = 'LANDING_PAGE_ACTIONS.SET_BANK_TRANSFER_NETWORK',
  SET_SELECTED_BANK_ACCOUNT = 'LANDING_PAGE_ACTIONS.SET_SELECTED_BANK_ACCOUNT',
  SET_SELECTED_CURRENCY = 'LANDING_PAGE_ACTIONS.SET_SELECTED_CURRENCY',
  SET_FLIPPERS = 'LANDING_PAGE_ACTIONS.SET_FLIPPERS',
  SET_ACTIVATION_CHECKLIST_CLICKED_ELEMENT = 'LANDING_PAGE_ACTIONS.SET_ACTIVATION_CHECKLIST_CLICKED_ELEMENT',
}

type SetBankTransferNetwork = {
  type:
    | typeof STRAITSX_LANDING_PAGE_ACTIONS.SET_BANK_TRANSFER_NETWORK
    | typeof LANDING_PAGE_ACTIONS.SET_BANK_TRANSFER_NETWORK
  bankTransferNetwork: BANK_TRANSFER_NETWORK | null
}

type SetSelectedBlockchainAddress = {
  type:
    | typeof STRAITSX_LANDING_PAGE_ACTIONS.SET_SELECTED_BLOCKCHAIN_ADDRESS
    | typeof LANDING_PAGE_ACTIONS.SET_SELECTED_BLOCKCHAIN_ADDRESS
  selectedBlockchainAddress: BlockchainAddress | null
}

type SetSelectedBlockchain = {
  type:
    | typeof STRAITSX_LANDING_PAGE_ACTIONS.SET_SELECTED_BLOCKCHAIN
    | typeof LANDING_PAGE_ACTIONS.SET_SELECTED_BLOCKCHAIN
  selectedBlockchain: Blockchain | null
}

type SetSelectedBankAccount = {
  type:
    | typeof STRAITSX_LANDING_PAGE_ACTIONS.SET_SELECTED_BANK_ACCOUNT
    | typeof LANDING_PAGE_ACTIONS.SET_SELECTED_BANK_ACCOUNT
  selectedBankAccount: BankAccount | null
}

type SetTransferMethod = {
  type:
    | typeof STRAITSX_LANDING_PAGE_ACTIONS.SET_TRANSFER_METHOD
    | typeof LANDING_PAGE_ACTIONS.SET_TRANSFER_METHOD
  transferMethod: TRANSFER_METHOD | null
}
type SetSelectedCurrency = {
  type:
    | typeof STRAITSX_LANDING_PAGE_ACTIONS.SET_SELECTED_CURRENCY
    | typeof LANDING_PAGE_ACTIONS.SET_SELECTED_CURRENCY
  selectedCurrency: STABLECOIN_TYPE | null
}

type SetFlippers = {
  type: typeof LANDING_PAGE_ACTIONS.SET_FLIPPERS | typeof STRAITSX_LANDING_PAGE_ACTIONS.SET_FLIPPERS
  flippers: Map<keyof StateFlippers, boolean>
}

type SetActivationChecklistClickedElement = {
  type:
    | typeof STRAITSX_LANDING_PAGE_ACTIONS.SET_ACTIVATION_CHECKLIST_CLICKED_ELEMENT
    | typeof LANDING_PAGE_ACTIONS.SET_ACTIVATION_CHECKLIST_CLICKED_ELEMENT
  activationChecklistClickedElement: string
}

export type ActionTypes =
  | SetTransferMethod
  | SetSelectedBlockchain
  | SetSelectedBlockchainAddress
  | SetBankTransferNetwork
  | SetSelectedBankAccount
  | SetSelectedCurrency
  | SetFlippers
  | SetActivationChecklistClickedElement
